import { useState, useEffect } from "react";
import "./AccountDetails.scss";
import { Edit, Clear } from "@mui/icons-material";

const AccountDetails = ({ currentUser, setCurrentUser }) => {
  const [editing, setEditing] = useState({ email: false, phone: false });
  const [tempInfo, setTempInfo] = useState({});

  useEffect(() => {
    if (currentUser) {
      setTempInfo(currentUser);
    }
  }, [currentUser]);

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isValidPhone = (phone) => /^\(\d{3}\) \d{3}-\d{4}$/.test(phone);

  const handleEdit = (field) => {
    setEditing((prev) => ({ ...prev, [field]: true }));
  };

  const handleCancel = (field) => {
    setTempInfo(currentUser);
    setEditing((prev) => ({ ...prev, [field]: false }));
  };

  const handleSave = (field) => {
    setCurrentUser((prev) => ({ ...prev, [field]: tempInfo[field] }));
    setEditing((prev) => ({ ...prev, [field]: false }));
  };

  return (
    <div className="account-card">
      <h1 className="account-title">Account Details</h1>
      
      <div className="account-info">
        <div>
          <label className="account-label">Username</label>
          <p className="account-text">{currentUser?.username}</p>
        </div>
        
        {['email', 'phone'].map((field) => (
          <div key={field} className="account-field">
            <div className="account-field-info">
              <label className="account-label">
                {field === 'email' ? 'Email' : 'Phone Number'}
              </label>
              {editing[field] ? (
                <input
                  type="text"
                  value={tempInfo[field]}
                  onChange={(e) => setTempInfo({ ...tempInfo, [field]: e.target.value })}
                  className="account-input"
                />
              ) : (
                <p className="account-text">{currentUser?.[field]}</p>
              )}
            </div>
            <div className="account-buttons">
              {editing[field] ? (
                <>
                  <button
                    className="submit-button"
                    onClick={() => handleSave(field)}
                    disabled={
                      field === 'email' ? !isValidEmail(tempInfo[field]) : !isValidPhone(tempInfo[field])
                    }
                  >
                    Submit
                  </button>
                  <button className="cancel-button styled-cancel-button" onClick={() => handleCancel(field)}>
                    <Clear />
                  </button>
                </>
              ) : (
                <button className="edit-button" onClick={() => handleEdit(field)}>
                  <Edit style={{ color: "gray" }} />
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AccountDetails;
